import React, { Component } from "react";

class GridOverlay extends Component {
    createGrid = () => {
        let grid = [];

        const columnCount = 16;

        for (let c = 0; c < columnCount; c++) {
            grid.push(<div key={c} className="grid-overlay__column" />);
        }

        return grid;
    };

    render() {
        return <div className="grid-overlay">{this.createGrid()}</div>;
    }
}

export default GridOverlay;



// WEBPACK FOOTER //
// ./src/scripts/components/GridOverlay.js